type AppConfig = {
  apiUrl: string;
  gaMeasurementId: string | null;
  launchDarklyKey: string;
};

declare global {
  interface Window {
    __config: AppConfig;
  }
}

export default window.__config || {
  apiUrl: "http://localhost:9000",
  gaMeasurementId: null,
  launchDarklyKey: "6303a50854e511124387c35c",
};
